module.exports = __webpack_public_path__ + "media/images/icon__font-awesome-plus-8efab27a299947e2f305afad2c547b7f.svg";